var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookAction(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#6D6D78"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.99 17.647c.375.24.813.362 1.258.352.283 0 .562-.053.825-.157l17.55-6.744c.868-.334 1.441-1.168 1.441-2.099 0-.93-.573-1.764-1.44-2.098L3.072.157C2.378-.117 1.593-.028.977.394.362.816-.004 1.516 0 2.262v13.49c-.011.758.361 1.47.99 1.895z",
    transform: "translate(-238 -148) rotate(-30 420.368 -367.444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9L22 9",
    transform: "translate(-238 -148) rotate(-30 420.368 -367.444)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAction);
export default __webpack_public_path__ + "static/media/book-action.9ad44135.svg";
export { ForwardRef as ReactComponent };